"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuButtonAction = exports.MenuButton = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("./button"));

var _contextual_menu = _interopRequireDefault(require("./shared/contextual_menu"));

var _popover = _interopRequireDefault(require("./shared/popover"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// This component is mantained to keep API compatibility using the ContextualMenu
var MenuButtonAction = function MenuButtonAction() {
  return null;
};

exports.MenuButtonAction = MenuButtonAction;
MenuButtonAction.propTypes = {
  disabled: _propTypes.default.bool,
  href: _propTypes.default.string,
  icon: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  onClick: _propTypes.default.func
};
MenuButtonAction.defaultProps = {
  disabled: false,
  href: null,
  icon: undefined,
  onClick: function onClick() {}
};
MenuButtonAction.displayName = 'MenuButtonAction';

var MenuButton = function MenuButton(_ref) {
  var children = _ref.children,
      label = _ref.label,
      menuAlignment = _ref.menuAlignment,
      menuPlacement = _ref.menuPlacement,
      menuPosition = _ref.menuPosition,
      menuUseJsPositioning = _ref.menuUseJsPositioning,
      onClick = _ref.onClick,
      otherProps = _objectWithoutProperties(_ref, ["children", "label", "menuAlignment", "menuPlacement", "menuPosition", "menuUseJsPositioning", "onClick"]);

  if (otherProps.disabled || otherProps.loading) {
    return _react.default.createElement(_button.default, otherProps, label);
  }

  var getOptions = function getOptions() {
    return _react.default.Children.map(children, function (child) {
      return _objectSpread({}, child.props, {
        value: child.props.label
      });
    });
  };

  var actionOnClick = function actionOnClick(event, option) {
    if (option.onClick) {
      option.onClick(event, option.value);
    }
  };

  var actions = _react.default.createElement(_contextual_menu.default, {
    options: getOptions(),
    onClick: actionOnClick
  });

  return _react.default.createElement(_popover.default, {
    alignment: menuAlignment,
    content: actions,
    placement: menuPlacement,
    position: menuPosition,
    targetRole: "button",
    useJsPositioning: menuUseJsPositioning
  }, _react.default.createElement(_button.default, _extends({}, otherProps, {
    onClick: onClick
  }), label));
};

exports.MenuButton = MenuButton;
MenuButton.propTypes = {
  appearance: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  label: _propTypes.default.string.isRequired,
  menuAlignment: _propTypes.default.oneOf(_popover.default.alignmentOptions),
  menuPlacement: _propTypes.default.oneOf(_popover.default.placementOptions),
  menuPosition: _propTypes.default.oneOf(_popover.default.positionOptions),
  menuUseJsPositioning: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
MenuButton.defaultProps = {
  appearance: null,
  disabled: false,
  menuAlignment: 'left',
  menuPlacement: 'manual',
  menuPosition: 'down',
  menuUseJsPositioning: false,
  onClick: undefined
};
MenuButton.displayName = 'MenuButton';
var _default = MenuButton;
exports.default = _default;